
export const HOOKS_DEEP_DIVE_QUIZ = {
  questions: [
    {
      id: "hooks-q1",
      question: "When should you use useCallback?",
      options: [
        "For all function definitions",
        "When passing functions as props to memoized components",
        "Only in class components",
        "Never, it's deprecated"
      ],
      correctAnswer: 1,
      correctAnswerIndex: 1,
      difficulty: "medium" as const
    },
    {
      id: "hooks-q2",
      question: "What is the main purpose of custom hooks?",
      options: [
        "Better performance",
        "Reusing stateful logic between components",
        "Replacing class components",
        "Managing global state"
      ],
      correctAnswer: 1,
      correctAnswerIndex: 1,
      difficulty: "medium" as const
    },
    {
      id: "hooks-q3",
      question: "What must custom hooks always start with?",
      options: [
        "useState",
        "The word 'use'",
        "useEffect",
        "A capital letter"
      ],
      correctAnswer: 1,
      correctAnswerIndex: 1,
      difficulty: "easy" as const
    }
  ]
};
